import React from "react";
import "./EditDocumentTemplate.scss";
import Modal from "react-bootstrap/Modal";
import closeIcon from "../../../assets/close.svg";

const EditDocumentTemplate = (props) => {
  return (
  
  <Modal
        className="new-template-modal"
        size="lg"
        centered
        show={props.showTabEditModal}
        onHide={props.tabEditCloseHandler}
      >
        <div className="new-template-modal-content">
          <div className="header">
            <h3 className="title">Edit Template</h3>
            <img
              className="close"
              src={closeIcon}
              alt="close"
              onClick={props.tabEditCloseHandler}
            />
          </div>

          <div className="body">
            <h3>Document Detail</h3>

            <div className="form-groups">
              <div className="form-group">
                <label>Document Type Name*</label>
                <input
                  autoFocus
                  type="text"
                  name="templateTitle"
                  maxLength="50"
                  value={props.templateTitle}
                  onChange={props.handleInputValueChange}
                  className={
                    props.errorMessage.length > 0
                      ? "form-control document-type error-input":
                       "form-control document-type"
                  }
                  placeholder="i.e. Legal Agreement"
                />
                {props.errorMessage.length > 0 && (
                  <span className="error">{props.errorMessage}</span>
                )}
              </div>

              <div className="form-group description-form-group">
                <label>Description*</label>
                <textarea
                  rows="1"
                  wrap="soft"
                  maxLength="300"
                  name="templateDescription"
                  className="form-control description"
                  value={props.templateDescription}
                  onChange={props.handleInputValueChange}
                />
              </div>

            
            </div>
          </div>

          <div className="footer">
            <button
              className="btn-tertiary cancel-button"
              onClick={props.tabEditCloseHandler}
            >
              Cancel
            </button>
            <button
              className="btn-primary create-button"
              disabled={props.errorMessage.length > 1 ? true : false}
              onClick={props.tabEditSaveHandler}
            >
              Save
            </button>
          </div>
        </div>
      </Modal>
  );
};

export default EditDocumentTemplate;
